//Stripe test environment
//export const stripe_sk = 'sk_test_51Mpb9rGQVQtCtlOAfvF3XpvbavtBlDAtMUB3IgwrTJRHUfRYVVD9v3Sad1xfP6EWcgVEbLivZa2Jk4DwsI3DdVov00iTLsT03A';
export const success_url_var = 'https://app.nclex.focuslearninghub.com/home/payment-status';
export const cancel_url_var = 'https://app.nclex.focuslearninghub.com/home/payment-status';
//Stripe live mode
export const stripe_sk = process.env.STRIPE_KEY_LIVE_2;
